import palette from '../palette'

export default {
  styleOverrides: {
    root: {
      color: palette.icon.primary,
      minWidth: 32
    }
  }
}
